export const reportTitals = {
  lblInterpretation: 'Interpretation of results',
  lblSummaryResultNo: 'Summary of results - numbers',
  lblCompareScenarioPackage:
    'The following table compares your scenarios on selected indicators for the complete product packaging system.  For detail impacts based on packaging configuration, materials and processes see the sections below.',
  lblTable: 'Table',
  lblLifeCycleImpact: 'Life cycle impacts',
  lblImageCategory: 'Category',
  lblNoTextAdded: 'No text added in this field',
  lblEquivalancyUnits: 'Equivalency unit',
  lblEquivalancyUnitsISO: 'Equivalence values - per package',
  lblCategory: 'Category',
  lblLifeCycleImpactScenario: 'Life cycle impacts relative to reference scenario',
  lblLowerImpact: '"-" = % lower impact than the base package',
  lblHigherImpact: '"+" = % higher impact than the base package',
  lblLifeCycleImpactAnnum: 'Life cycle impacts - per annum ',
  lblCat_Indicator: 'Category[indicator]',
  lblPackingMatrics: 'Packaging metrics',
  lblMaterialCertification: 'Material certification',
  lblCriteria: 'Criteria',
  lblCircularEconomyMetrics: 'Circular economy metrics',
  lblGlobalPackagingMetric: 'Global packaging protocol metric',
  lblPackagingLevelMetric: 'Packaging level metric',
  lblEndofLifeBreakdown: 'End-of-life breakdown',
  lblNoData: 'No record is available',
  lblInterpretationResults: 'Interpretation of results',
  lblLifeCyclesStages: 'Contribution by life cycle stage',
  lblSectionLifeCycleStage:
    'This section shows in detail the impacts for each scenario by life cycle stage for each of the selected environmental indicators based on the chosen functional unit.',
  lblLifeCycleStage: 'Life cycle stage',
  lblPackingLevel: 'Contribution by packaging level',
  lblIndicator: 'Indicator(unit)',
  lblComponents: 'Contribution by packaging components',
  lblPackagingComponents: 'contribution by packaging components',
  lblIngredient: 'Contribution by ingredients',
  lblPackagingIngredient: 'contribution by ingredients',
  lblScenarioDetails: 'Scenario details',
  lblScenarioName: 'Scenario name:',
  lblInputData: 'Input data',
  lblPackagingLevels: 'Packaging levels',
  lblUnit: 'Unit',
  lblQtyPackLevel: 'Quantity in packaging level',
  lblPackDetail: 'Package level detail',
  lblTotalUnitPerPallet: 'Total units per pallet unit',
  lblDetailsComponents: 'Details of components',
  lblComponent: 'Component',
  lblMaterial: 'Material',
  lblSupplierName: 'Name of supplier',
  lblCountry: 'Country',
  lblWeight: 'Weight (grams)',
  lblRecycledContent: 'Recycled content',
  lblRecycledAllocationFactor: 'Recycled allocation factor',
  lblDetailsComponent: 'Details of components',
  lblPackagingLevel: 'Packaging level',
  lblTransportationConvertor: 'Transportation to convertor',
  lblDescription: 'Description',
  lblModeTransport: 'Mode of transport',
  lblFrom: 'From',
  lblTo: 'To',
  lblDistance: 'Distance (km)',
  lblConversionProcess: 'Conversion process',
  lblConvertorName: 'Name of convertor',
  lblTransportationFiller: 'Transportation of package to the filler',
  lblFillingDetails: 'Filling details',
  lblEnergyRequirement: 'Energy requirement',
  lblAmount: 'Amount (per kg or per L per product)',
  lblProductLossFilling: 'Product loss in filling (%)',
  lblReusedProductLoss: 'Reused product from the loss (%)',
  lblResaleProduct: 'Resale of product at a value of % of original value',
  lblDestinationProductLoss: 'Destination of product loss',
  lblTransportationWholesaler: 'Transportation to wholesaler',
  lblDetailPalletUsed: 'Details of pallet used',
  lblPalletWeight: 'Pallet weight',
  lblWholesaleDetails: 'Wholesale details',
  lblInput: 'Input',
  lblTransportationRetailer: 'Transportation to retailer',
  lblRetailDetails: 'Retail details',
  lblTransportationConsumer: 'Transportation to consumer',
  lblConsumerDetails: 'Consumer details',
  lblTransportationReuse: 'Transportation to reuse',
  lblReusedComponent: 'Reused component',
  lblReuseDetails: 'Reuse details',
  lblReused: 'Reused (%)',
  lblReuseProcess: 'Reuse process',
  lblEndLifeDetail: 'End-of-life details',
  lblDetailProduct: 'Details of product',
  lblAmounts: 'Amount',
  lblResultScenario: 'Results for scenario',
  lblProductDetails: 'Product details',
  lblIngredientDataSource: 'Ingredient data source',
  lblIngredients: 'Ingredient',
  lblSource: 'Source',
  lblTimePeriod: 'Time period',
  lblGeoGraphy: 'Geography',
  lblProcess: 'Process',
  lblCatergoriesDefinition: 'Categories definition',
  lblOnlyIndicator: 'Indicator',
  lblClimateChange: 'Climate Change',
  climateDescription:
    'Climate change effects resulting from the emission of carbon dioxide (CO2), methane or other global warming gases into the atmosphere - this indicator is represented in CO2 equivalents. Factors applied to convert greenhouse gas emissions into CO2 equivalents emissions conform to the IPCC fourth assessment (Solomon, Qin et al. 2007). Characterization factors area adopted for a 100 year time horizon.',
  lblOzoneDepletion: 'Ozone depletion',
  OzoneDepletionDescription:
    'EDIP model based on the ODPs of the World Meteorological Organization (WMO) over an infinite time horizon.(World Meteorological Organization (WMO) 1999).  All factors are equivalent to CFC11 (Trichlorofluoromethane).',
  lblHumanToxicityCancerEffects: 'Human Toxicity - cancer effects',
  HumanToxicityCancerDescription:
    'Chemical impacts of humans via carcinogenesis USEtox model is a consensus based model taking account of the full fate and exposure pathways to aquatic fresh water,(Rosenbaum, Bachmann et al. 2008). All factors are reported in CTUh (Comparative Toxic Unit for humans).',
  lblHumanToxicityNonCancer: 'Human Toxicity - non-cancer effects',
  HumanToxicityNonCancerDescription:
    'Chemical impacts of humans via non-carcinogenic effects. USEtox model is a consensus based model taking account of the full fate and exposure pathways to aquatic fresh water,(Rosenbaum, Bachmann et al. 2008). All factors are reported in CTUh (Comparative Toxic Unit for humans).',
  lblParticulateMatter: 'Particulate matter',
  ParticulateMatterDescription:
    'This impact category looks at the health impacts from particulate matter for PM10 (particulate matter less than 10 µm) and PM2.5 (particular matter less than 2.5 µm). This is one of the most dominant immediate risks to human health as identified in the global burden of disease. World impact plus method (Humbert, Marshall et al. 2011).',
  lblIonisingRadiationHH: 'Ionizing Radiation - HH',
  IonisingRadiationDescription:
    'Measurement of human health impacts from radiation predominantly from radioactive substances associated with nuclear fuel cycle. Dreicer et al., 1995.',
  lblPhotochemicalOzoneFormation: 'Photochemical ozone formation',
  PhotochemicalOzoneDescription:
    'Measurement of the increased potential of photochemical smog events due to the chemical reaction between sunlight and specific gases released into the atmosphere. These gases include nitrogen oxides (NOx), volatile organic compounds (VOCs), peroxyacyl nitrates (PANs), aldehydes and ozone.LOTOS-EUROS model kg NMVOC equivalent Van Zelm et al., 2008 as applied in ReCiPe model.',
  lblAcidification: 'Acidification',
  AcidificationDescription:
    'Measurement of the emission of acid gases in the atmosphere.  These include sulfur oxides and ammonia.  The indicator is based on the accumulated exceedance model. Seppälä et al.,2006; Posch et al., 2008.',
  lblEutrophicationTerrestrial: 'Eutrophication - terrestrial',
  EutrophicationTerrestrialDescription:
    'Terrestrial eutrophication represents damages from anthropogenic release of N to natural ecosystem and plant communities. It is only affected by Nitrogen emission to air which can deposit on natural soil. It results in changes in species composition and soil processes. It’s measured in mol N. The indicator is based on the accumulated exceedance model. Seppälä et al.,2006; Posch et al., 2008.',
  lblEutrophicationFreshWater: 'Eutrophication - fresh water',
  EutrophicationFreshWaterDescription:
    'Eutrophication refers to the nutrient enrichment of waterways which result in increasing algae and plant growth and deep leading oxygen in the water body. Freshwater eutrophication is typically dominated phosphate emissions. The model is based EUTREND model as implemented in ReCiPe Struijs et al., 2009.',
  lblEutrophicationMarine: 'Eutrophication - marine',
  EutrophicationMarineDescription:
    'Marine eutrophication refers to saline waters predominantly in coastal areas and estuaries and is typically limited by the nitrogen supply.  The model is based EUTREND model as implemented in ReCiPe Struijs et al., 2009.',
  lblEcotoxicityFreshWater: 'Ecotoxicity - fresh water',
  EcotoxicityFreshWaterDescription:
    'Many chemicals have an effect biodiversity especially water borne species.  USEtox model is a consensus based model taking account of the full fate and exposure pathways to aquatic fresh water,(Rosenbaum, Bachmann et al. 2008) All factors are reported in CTUe (Comparative Toxic Unit for ecosystems).',
  lblLandUseImpact: 'Land use impact',
  LandUseImpactDescription:
    'The method is based on the increase or decrease in soil organic matter (SOM) as a function of land use change (LUC) and land use occupation. It is based on the difference in the SOM from a natural reference state. ILCD method (European Commission JRC IES 2011) based on Mila-i-Canals (i Canals, Romanya et al. 2007).',
  lblLandOccupation: 'Land occupation',
  LandOccupationDescription:
    'The occupation of land in the production system, measured in area and time.',
  lblResourceDepletionWater: 'Resource depletion - water',
  ResourceDepletionWaterDescription:
    'Water use is based on the Swiss echo scarcity model (Frischknecht et al., 2008) take account of both the amount of water used and the water stress in the area where the water is taken from.',
  lblWaterUseVolume: 'Water use volume',
  WaterUseVolumeDescription:
    'Total of all water used by the processes considered, except turbined water used in hydro generation of electricity.',
  lblAbiotic: 'Abiotic Depletion - mineral, fossil',
  AbioticDepletionMineralFossilDescription:
    'The additional energy required to extract mineral&amp; fossil fuel resources due to depletion of reserves, leaving lower quality reserves behind. The minerals and fossil fuel indicator has been designed from the Eco-Indicator impact assessment method (Goedkoop and Spriensma, 2001).',
  lblResourceDamage: 'Resource damage - mineral, fossil',
  ResourceDamageMineralFossilDescription:
    'Resource Damage indicator is taken from the Recipe method developed in Europe, and is a measure of the impact of depleting current resources on future generations through additional cost incurred to meet their resource needs. The measure is in surplus cost, however as the calculation uses a specific timeframe for calculating the damage - the surplus cost value should not be added to an economic assessment.',
  lblCumulativeEnergyDemand: 'Cumulative Energy Demand',
  CumulativeEnergyDemandDescription:
    'All energy use including fossil, renewable, and nuclear energy are taken into account, including feedstock (energy incorporated into materials such as plastic). The energy indicator has been designed on the basis on the first CML impact assessment method (Heijungs, 1992a; Heijungs , 1992b ).',
  lblSolidWaste: 'Solid Waste',
  SolidWasteDescription:
    'Total of all solid waste generated by the processes considered. This indicator has been designed according to the first CML impact assessment method (Heijungs, 1992a; Heijungs , 1992b). Note that the CML 92 is the only European impact assessment method that takes solid waste into account.',
  lblDataSource: 'Data source and attributes',
  lblMaterials: 'Materials',
  lblComponentName: 'Component name',
  lblConversion: 'Conversion',
  lblSummaryProject: ' Summary of project details',
  lblSummaryScenarios: ': Summary of scenarios assessed',
  lblSummaryResult: 'Graphical summary of results',
  lblProductIngredient: 'Product Ingredient',
  lblProductManufacturing: 'Product Manufacturing',
  lblFilling: 'Filling',
  lblWholesale: 'Wholesale',
  lblRetail: 'Retail',
  lblConsumer: 'Consumer',
  lblEndLife: 'End-of-life',
  lblScenarioCategories: ' Scenario comparison across various categories',
  lblProductLoss: 'Contribution of product losses',
  lblProductLossImpact:
    'This section shows the impact for product losses through the supply chain.  Note that PIQET makes no estimate of product losses as these need to be estimated by the users.  Also note that the product impacts are estimated based on sector averages and not specific modelled product data.',
  lblProductWaste:
    'Contribution of product waste all selected indicators use full version but have option for compact version with mini graphs',
  lblScenarioComparison: 'Scenario Comparison',
  lblCarbonLifeCycle:
    'This section shows in detail the carbon footprint for each scenario by life cycle stage.',
  lblContributionTransport: 'Contribution of transport',
  lblCarbonTransportLevel: 'Contribution of transport',
  lblComparison: 'comparison',
  lblCarbonFootprintReport: 'Carbon Footprint Report',
  lblCarbonIngredientLevel:
    ' This section shows the carbon footprint for each product ingredient with product manufacture reported separately and the remaining impacts reported under packaging filling and distribution.  Each ingredient includes production of that ingredient as well as its transport to manufacturing.',
  lblCarbonFootPrint: 'Carbon footprint',
  lblCarbonPackagingLevel:
    'This section shows the carbon footprint for each packaging level with product logistics and product loss included separately.  Each packaging level includes the materials, transport, conversion and end-of-life for materials in that packaging level.',
  lblLifeCycle: 'contribution by life cycle stage',
  lblPackingLevelStage: 'contribution by packaging levels',
  lblDetailedReport: 'Detailed report',
  lblCompactReport: 'Compact report',
  lblFigure: 'Figure',
  lblAllLifeCycle: 'Contribution analysis of all life cycle stages',
  lblContributionProductWaste: 'contribution of product waste',
  lblCarbonComponentLevel:
    'This section shows the carbon footprint for each packaging component with product filling and distribution included separately.  Each packaging component includes the materials, transport, conversion and End of Life impacts for that component.',
  lblCarbonPackagingLevelIndicator:
    'Contribution by packaging level all selected indicators use full version but have option for compact version with mini graphs',
  lblEolDiscription:
    'End-of-life rates are based on region waste processing data and global defaults.',
  lblEolReuseOfComponent: 'Reuse of components',
  lblImpactCategoriesDefinition: 'Impact categories definition',
  lblBackgroundData: 'Background data',
  lblReuse: 'Reuse',
  lblReuseComponent: 'Component',
  lblTransport: 'Transport',
  lblReuseReuse: 'Reuse (%)',
  lblReuseType: 'Type',
  lblReuseNoOfTrip: 'No of trips',
  lblReuseProcessEol: 'Process',
  lblReuseAmount: 'Amount',
  lblRetailEndoflife: 'Retail End-of-life',
  lblMaterialName: 'Material',
  lblComponentNameEol: 'Component',
  lblLandFill: 'Landfill %',
  lblRecycling: 'Recycling %',
  lblHomeComposting: 'Home composting %',
  lblCommercialComposting: 'Commercial composting %',
  lblIncineration: 'Incineration %',
  lblWasteEnergyRecovery: 'Energy recovery %',
  lblOpenDump: 'Open dump %',
  lblAnerobicDigestion: 'Anaerobic digestion %',
  lblLitter: 'Litter %',
  lblStormWater: 'Storm water %',
  lblSewer: 'Sewer %',
  lblRecyclingOpenLoop: 'Recycling, open loop %',
  lblChemicalRecycling: 'Chemical recycling %',
  lblPyrolysis: 'Pyrolysis/Gasification %',
  lblOpenBurning: 'Open burning %',
  lblNone: 'None %',
  lblEolFates: 'Material end-of-life fates',
  lblConsumerEndoflife: 'Consumer End-of-life',
};

export enum ImpactDataFormateEnum {
  Default = 0,
  Percentage = 1,
  Units = 2,
}
